import { createFileRoute, redirect } from '@tanstack/react-router'
import SignIn2 from '@/features/auth/sign-in/sign-in-2'
import { useAuthStore } from '@/stores/authStore'

export const Route = createFileRoute('/(auth)/sign-in-2')({
  beforeLoad: () => {
    const token = useAuthStore.getState().auth.accessToken
    if (token) throw redirect({ to: '/' })
  },
  component: SignIn2,
})
